import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  input,
  OnChanges,
  SimpleChanges,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'app-mgt-person',
  template: `<mgt-person #mgtPerson view="oneline"></mgt-person> `,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TvaMgtPersonComponent implements OnChanges {
  userId = input.required<string>();
  mgtPerson = viewChild<ElementRef>('mgtPerson');
  view = input<'oneline' | 'twolines'>('oneline');

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userId'] && changes['userId'].currentValue) {
      this.mgtPerson()?.nativeElement.setAttribute('user-id', this.userId());
    }
    if (changes['view'] && changes['view'].currentValue) {
      this.mgtPerson()?.nativeElement.setAttribute('view', this.view());
    }
  }
}
